import { gtmEvent } from 'app/modules/gtm/service/gtm.service';
import { globalError, TYPE_ERROR } from 'app/shared/error/error-global';
import { translate } from 'react-jhipster';
import { corporateApi } from '../api';
import { ACTION_TYPES } from './store/corporate.actions';
import { Offer } from './store/corporate.state';
import { base64ToBlob, getDocumentPathFromProductCode } from 'app/shared/util/method-util';
import { getSubscriptionToken } from 'app/shared/util/method-util';

export const getSelectedOffer = (offerNumber: string) => async dispatch => {
  const result: any = await corporateApi.getSelectedOffer(offerNumber);

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  const offer = result.getValue();

  const selectedOffer: Offer = {
    code: offer.code,
    title: offer.title,
    description: offer.description,
    showAmount: offer.showAmount,
    contribution: offer.contribution,
    IPIDUrl: 'http://IPID3',
    IPIDUrlTitle: translate('form.steps.offersOverview.documentLink'),
    covers: offer.coverItems,
    extras: offer.extraItems,
    badgeURL: offer.badgeURL,
    eurTaxInclAmount: offer.eurTaxInclAmount,
    coverTitle: offer.coverTitle,
    coverDetails: offer.coverDetails,
    extraTitle: offer.extraTitle,
    extraIconURL: offer.extraIconURL,
    extraDetails: offer.extraDetails,
    accessibility: offer.accessibility,
    documents: offer.documents
  };

  dispatch({
    type: ACTION_TYPES.SET_SELECTED_OFFER,
    payload: selectedOffer
  });
};

export const getDocumentContent = (offerNumber: string, documentUuid: string, TypeName?: string) => async dispatch => {
  const result: any = await corporateApi.getDocumentContent(offerNumber);

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  const url = window.URL.createObjectURL(new Blob([result.getValue()], { type: 'application/pdf' }));

  await dispatch({
    type: ACTION_TYPES.SET_DOC_URL,
    payload: { code: TypeName ? TypeName : offerNumber, docUrl: url }
  });
};

export const openPageMarketing = page => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.OPEN_PAGE_MARKETING,
    payload: { page }
  });
};

export const hidePageMarketing = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.HIDE_PAGE_MARKETING
  });
};

export const openDocument = (url, type) => async dispatch => {
  window.open(url);
  await dispatch(gtmEvent(type, 'pdf ' + type, '0'));
};

// isured goods
export const initializeInsuredGoods = () => async (dispatch, getState) => {
  const result = await corporateApi.getInsuredGoods();

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  await dispatch({ type: ACTION_TYPES.INITIALIZE_INSUREDGOODS, payload: result.getValue() });

  const { contextSales, products } = await getState().corporate;

  // TODO: revoir la récupération des données du contexte
  if (contextSales !== undefined && contextSales.elementsGood !== undefined) {
    const _products = { ...products };

    (contextSales.elementsGood as any[]).forEach(el => {
      const goodIndex = _products.insuredGoods.findIndex(e => e.type.code === el.typeCode);

      const good = _products.insuredGoods[goodIndex];
      good.purchasePrice = {
        amount: el.purchasePrice,
        currency: el.currency,
        taxIncl: el.taxIncl
      };
      good.purchaseDate = el.purchaseDate;
    });

    await dispatch({ type: ACTION_TYPES.UPDATE_INSUREDGOODS_PURCHASE_DATE, payload: _products.insuredGoods });
  }
};

export const updateInsuredGood = (index, elementGood) => async dispatch => {
  await dispatch({ type: ACTION_TYPES.UPDATE_INSUREDGOOD, payload: { index, elementGood } });
};

export const updateInsuredGoodAmount = (index, amount) => async dispatch => {
  await dispatch({ type: ACTION_TYPES.UPDATE_INSUREDGOOD_AMOUNT, payload: { index, amount } });
};

export const updateInsuredGoodsPurchaseDate = insuredGoods => async dispatch => {
  await dispatch({ type: ACTION_TYPES.UPDATE_INSUREDGOODS_PURCHASE_DATE, payload: insuredGoods });
};

export const fetchOfferDocuments = offerCode => async dispatch => {
  dispatch({ type: ACTION_TYPES.FETCH_OFFER_DOCUMENTS, payload: { offerCode } });
  try {
    const response = await corporateApi.getOfferDocuments(offerCode);

    dispatch({
      type: ACTION_TYPES.FETCH_OFFER_DOCUMENTS_SUCCESS,
      payload: {
        offerCode,
        documents: response.getValue()
      }
    });
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.FETCH_OFFER_DOCUMENTS_ERROR,
      payload: {
        offerCode,
        error: error.message
      }
    });
  }
};

export const processOfferDocuments = (productCode: number, offerNumber: string) => async dispatch => {
  // Filtre les documents qui nous intéressent (NI, IPID)
  const documentPath = getDocumentPathFromProductCode(productCode);
  const relevantDocs = [
    {
      type: 'NI',
      fileDisplayName:  "Notice d'information"
    },
    {
      type: 'IPID',
      fileDisplayName:  "Document d'Information sur le Produit d'Assurance"
    }
  ];

  for (const doc of relevantDocs) {
    try {
      await dispatch({
        type: ACTION_TYPES.SET_OFFER_DOC_URL,
        payload: {
          offerNumber,
          docType: doc.type,
          info: {
            fileDisplayName: doc.fileDisplayName,
            type: doc.type,
            docUrl: "https://assurances.spb.eu/documents/" + documentPath + "/" + doc.type+ ".pdf"
          }
        }
      });
    } catch (error) {
      console.error(`Error processing document`, error);
    }
  }
};

export const fetchSignCertifiedDocuments = (subscriptionNumber) => async dispatch => {
  dispatch({ type: ACTION_TYPES.FETCH_SIGN_CERTIFIED_DOCUMENTS, payload: { subscriptionNumber } });

  const token = getSubscriptionToken(subscriptionNumber)

  try {
    const response = await corporateApi.getSignCertifiedDocuments(subscriptionNumber, token);

    dispatch({
      type: ACTION_TYPES.FETCH_SIGN_CERTIFIED_DOCUMENTS_SUCCESS,
      payload: {
        subscriptionNumber,
        documents: response.getValue()
      }
    });
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.FETCH_OFFER_DOCUMENTS_ERROR,
      payload: {
        subscriptionNumber,
        error: error.message
      }
    });
  }
};



/**
 * Télécharge un document via l'URL signée avec token dans le header
 */
const downloadDocumentViaSignedUrl = async (docInfo: any, subscriptionNumber: string): Promise<string> => {
  const documentToken = docInfo.accessInfo?.headers?.['X-Document-Token'];

  if (!documentToken) {
    throw new Error(`No document token for type ${docInfo.type}`);
  }

  const response = await corporateApi.getSignedDocumentContent(
    subscriptionNumber,
    docInfo.type,
    documentToken
  );

  if (response.isFailure) {
    throw new Error(`Failed to download document: ${response.errorValue()}`);
  }

  const blob = response.getValue();
  return window.URL.createObjectURL(blob);
};

export const processSignCertifiedDocuments = (subscriptionNumber: string, offerNumber: string) => async dispatch => {
  try {
    const token = getSubscriptionToken(subscriptionNumber);
    const response: any = await corporateApi.getProcessedDocuments(subscriptionNumber, token);
    const processedData = response.data;

    // Traiter les documents en parallèle
    const documentPromises = Object.entries(processedData.documents).map(
      async ([docType, docInfo]: [string, any]) => {

        let docUrl: string;

        try {
          // Télécharger le document via l'URL signée
          docUrl = await downloadDocumentViaSignedUrl(docInfo, subscriptionNumber);
        } catch (error) {
          console.error(`Failed to download ${docType}:`, error);

          docUrl = docInfo.docUrl;
        }

        return {
          offerNumber,
          docType: docInfo.type,
          info: {
            fileDisplayName: docInfo.fileDisplayName,
            type: docInfo.type,
            docUrl,
            accessInfo: docInfo.accessInfo
          }
        };
      }
    );

    const documents = await Promise.all(documentPromises);

    documents.forEach(document => {
      dispatch({
        type: ACTION_TYPES.SET_SIGN_CERTIFIED_DOC_URL,
        payload: document
      });
    });

  } catch (error) {
    console.error('Error processing certified documents:', error);
  }
};
